import React from "react";
import Link from "@mui/material/Link";
import { NormalText } from "../../../../components/TextParts";

const preventDefault = (event) => {
  event.preventDefault();
};

export default function MailListItem({ name, text }) {
  return (
    <Link
      href="#"
      onClick={preventDefault}
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: { xs: "20px", sm: "40px" },
        textDecoration: "none",
        borderTop: 1,
        borderBottom: 1,
        borderColor: "#eee",
        py: "20px",
      }}
    >
      <NormalText text={name} />
      <NormalText text={text} />
    </Link>
  );
}